import { React, StyledProps, withStyles, classNames } from '@api'
import { CircularProgress } from '@material-ui/core'

const styles = theme => ({
  uploading: {
    width: 250,
    height: 250,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

interface MyProps extends StyledProps {
  size?: number
}

export class LoadingComponent extends React.Component<MyProps> {
  render () {
    const {
      size,
      classes,
      className
    } = this.props
    return (
      <div className={classNames(className, classes.uploading)}><CircularProgress color={'secondary'} size={size || 50}/></div>
    )
  }
}

@(withStyles  as any)(styles)
export class Loading extends LoadingComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Loading.tsx